import * as React from 'react';
import { Fragment } from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';
import { StartRelative } from './StartRelative';
import { StartSpecific } from './StartSpecific';
import { EndRelative } from './EndRelative';
import { EndSpecific } from './EndSpecific';
import { TimeRange } from './TimeRange';
import { ReportType } from 'types';
import { hasFeature } from 'logic/reports/reportType';

export type OwnProps = {
    reportSettings: Readonly<ReportSettings>;
    reportType: ReportType;
    onChange: ReportSettingsChangeHandler;
};

const styles = {
    indented: {
        marginLeft: '2em',
    },
    topMargin: {
        marginTop: '1em',
    },
};

export const RawDateRangeSection = ({ t, ...props }: OwnProps & TranslateProps) =>
    <Fragment>
        <div>
            { t('WC_SCHEDULE_DATA_START') }
        </div>
        <div style={ styles.indented }>
            <StartRelative { ...props }/>
            <StartSpecific { ...props }/>
        </div>
        <div style={ styles.topMargin }>
            { t('WC_SCHEDULE_DATA_END') }
        </div>
        <div style={ styles.indented }>
            <EndRelative { ...props }/>
            <EndSpecific { ...props }/>
        </div>
        <div style={ styles.topMargin }>
            { !hasFeature(props.reportType, 'noTimeRange') ? <TimeRange { ...props } /> : null }
        </div>
    </Fragment>
;

export const DateRangeSection = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('DateRangeSection'),
    translate(),
)(RawDateRangeSection);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/dateRange/DateRangeSection.tsx